import { render, staticRenderFns } from "./Stamp.vue?vue&type=template&id=4ad72807&scoped=true"
import script from "./Stamp.vue?vue&type=script&lang=js"
export * from "./Stamp.vue?vue&type=script&lang=js"
import style0 from "./Stamp.vue?vue&type=style&index=0&id=4ad72807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad72807",
  null
  
)

export default component.exports